import DesignServicesIcon from "@mui/icons-material/DesignServicesRounded";
import LocalShippingIcon from "@mui/icons-material/LocalShippingRounded";
import { Box, SvgIcon } from "@mui/material";
import { styled, useTheme } from "@mui/material/styles";
import Tab, { TabProps } from "@mui/material/Tab";
import Tabs, { tabsClasses } from "@mui/material/Tabs";
import useMediaQuery from "@mui/material/useMediaQuery";
import * as React from "react";
import { Container } from "../index";
import Customization from "./customization";
import Material from "./material";
import Shipping from "./shipping";

const CustomTabs = styled(Tabs)(({ theme }) => ({
  maxWidth: theme.breakpoints.values.lg,
  marginLeft: "auto",
  marginRight: "auto",
  "& .MuiTabs-indicator": {
    backgroundColor: theme.palette.text.primary,
  },
}));

const CustomTab = styled((props: TabProps) => <Tab disableRipple {...props} />)(
  ({ theme }) => ({
    fontSize: theme.typography.subtitle1.fontSize,
    [theme.breakpoints.down("sm")]: {
      fontSize: theme.typography.body1.fontSize,
    },
  })
);

interface TabPanelProps {
  children?: any;
  index: number;
  value: number;
}

function TabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <Container
      // size="xl"
      role="tabpanel"
      hidden={value !== index}
      id={`product-tabpanel-${index}`}
      aria-labelledby={`product-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ py: 4 }}>{children}</Box>}
    </Container>
  );
}

const TabLabel = styled("div")(({ theme }) => ({
  fontSize: theme.typography.body1.fontSize,
  display: "flex",
  alignItems: "center",
  "& svg": {
    fontSize: 28,
    marginRight: theme.spacing(1),
  },
}));

function a11yProps(index: number) {
  return {
    id: `product-tab-${index}`,
    "aria-controls": `product-tabpanel-${index}`,
  };
}

const FeatureIcon = () => {
  return (
    <SvgIcon viewBox="0 0 1024 1024">
      <path d="M346.1 698.3c-15.2-15.2-7.3-10.9-43.9-20.7-16.6-4.5-31.3-13-44.5-23.3l-79.4 194.6c-7.7 18.8 6.7 39.3 27 38.5l92.2-3.5 63.4 67c14 14.8 38.6 10.2 46.2-8.7l91.1-223.3c-19 10.6-40 16.8-61.8 16.8-34.1-0.1-66.1-13.3-90.3-37.4z m499.8 150.5l-79.4-194.6c-13.2 10.3-27.8 18.8-44.5 23.3-36.9 9.9-28.8 5.6-43.9 20.7-24.1 24.1-56.2 37.4-90.3 37.4-21.8 0-42.8-6.2-61.8-16.8l91.1 223.3c7.7 18.8 32.3 23.4 46.2 8.7l63.4-67 92.2 3.5c20.3 0.8 34.7-19.7 27-38.5zM636.3 658.7c26.7-27.2 29.8-24.9 67.9-35.2 24.3-6.6 43.3-26 49.8-50.7 13.1-49.7 9.7-43.7 45.4-80 17.8-18.1 24.7-44.5 18.2-69.2-13.1-49.6-13.1-42.7 0-92.4 6.5-24.7-0.4-51.1-18.2-69.2-35.7-36.4-32.3-30.4-45.4-80-6.5-24.7-25.5-44.1-49.8-50.7-48.8-13.3-42.9-9.8-78.6-46.2-17.8-18.1-43.7-25.2-68-18.6-48.8 13.3-41.9 13.3-90.8 0-24.3-6.6-50.2 0.4-68 18.6-35.7 36.4-29.8 32.9-78.6 46.2-24.3 6.6-43.3 26-49.8 50.7-13.1 49.7-9.7 43.7-45.4 80-17.8 18.1-24.8 44.5-18.2 69.2 13.1 49.6 13.1 42.7 0 92.4-6.5 24.7 0.4 51.1 18.2 69.3 35.7 36.4 32.3 30.4 45.4 80 6.5 24.7 25.5 44.1 49.8 50.7 39.2 10.7 42.1 9 67.8 35.2 23.1 23.6 59.2 27.8 87 10.2 22.7-14.4 51.7-14.4 74.4 0 27.7 17.4 63.8 13.2 86.9-10.3z m-289.2-287c0-92.8 73.9-168 165-168s165 75.2 165 168-73.9 168-165 168-165-75.2-165-168z" />
    </SvgIcon>
  );
};

const ShirtIcon = () => {
  return (
    <SvgIcon viewBox="0 0 1126 1024">
      <path
        d="M871.160938 967.449909H258.800361c-24.986092 0-45.240073-20.258505-45.240073-45.240073v-434.051354a45.240073 45.240073 0 0 1-38.942655-12.712461L45.887006 346.71087a45.244597 45.244597 0 0 1 0-63.978511L285.9625 42.656865c17.661724-17.661724 46.307739-17.666248 63.978511 0l102.717585 102.708537h221.178716L776.54585 42.656865c17.675296-17.661724 46.312263-17.661724 63.983035 0l240.07097 240.07097c17.666248 17.666248 17.666248 46.312263 0 63.983035l-128.735151 128.735151a45.253645 45.253645 0 0 1-31.989256 13.250817c-1.16267 0-2.320816-0.04524-3.469913-0.131196v211.185184c0 24.981568-20.258505 45.240073-45.240073 45.240073s-45.240073-20.258505-45.240073-45.240073v-305.008571a45.240073 45.240073 0 0 1 77.229329-31.989255l16.716206 16.720731 64.752117-64.752116-176.09246-176.09246-83.974623 83.970099a45.253645 45.253645 0 0 1-31.989255 13.250818H433.915634a45.253645 45.253645 0 0 1-31.989255-13.250818L317.951756 138.624631 141.854772 314.721615 206.606889 379.473731l20.199692-20.204217a45.240073 45.240073 0 0 1 77.229328 31.989256v485.710993h521.880432v-32.455228c0-24.981568 20.258505-45.240073 45.240073-45.240073s45.240073 20.258505 45.240073 45.240073v77.695301c0.004524 24.981568-20.249457 45.240073-45.235549 45.240073z"
        fill="inherit"
      />
      <path
        d="M494.451376 598.114479a45.113401 45.113401 0 0 1-31.989256-13.250818c-17.666248-17.666248-17.670772-46.312263 0-63.983035L610.831463 372.50676c17.670772-17.666248 46.307739-17.670772 63.983035 0 17.666248 17.666248 17.666248 46.312263 0 63.97851l-148.369343 148.378391a45.104353 45.104353 0 0 1-31.993779 13.250818zM494.4559 783.404245a45.104353 45.104353 0 0 1-31.989256-13.250818c-17.666248-17.666248-17.666248-46.312263 0-63.983035l148.373867-148.373866c17.675296-17.661724 46.312263-17.6572 63.983035 0 17.666248 17.666248 17.666248 46.312263 0 63.983035l-148.378391 148.373866a45.086257 45.086257 0 0 1-31.989255 13.250818z"
        fill="inherit"
        opacity={0.8}
      />
    </SvgIcon>
  );
};

export default function Options(): React.ReactElement {
  const [tab, setTab] = React.useState(0);
  const theme = useTheme();
  const matches = useMediaQuery(theme.breakpoints.down("md"));

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setTab(newValue);
  };

  return (
    <Box
      sx={(theme) => ({
        mx: "auto",
        mt: 4,
      })}
    >
      <Box
        sx={{
          borderBottom: "1px solid",
          borderColor: theme.palette.divider,
        }}
      >
        <CustomTabs
          value={tab}
          allowScrollButtonsMobile
          onChange={handleChange}
          aria-label="product-detail-tabs"
          // indicatorColor="inherit"
          textColor="inherit"
          scrollButtons={!!matches}
          variant={matches ? "scrollable" : "standard"}
          centered={!matches}
          sx={{
            [`& .${tabsClasses.scrollButtons}`]: {
              "&.Mui-disabled": { opacity: 0.3 },
            },
          }}
        >
          {/* <CustomTab
            label={
              <TabLabel>
                <FeatureIcon />
                Description
              </TabLabel>
            }
            {...a11yProps(1)}
          /> */}
          <CustomTab
            label={
              <TabLabel>
                <ShirtIcon />
                Material & Fit
              </TabLabel>
            }
            {...a11yProps(0)}
          />
          <CustomTab
            label={
              <TabLabel>
                <LocalShippingIcon />
                Shipping
              </TabLabel>
            }
            {...a11yProps(1)}
          />
          <CustomTab
            label={
              <TabLabel>
                <DesignServicesIcon />
                Customization
              </TabLabel>
            }
            {...a11yProps(2)}
          />
        </CustomTabs>
      </Box>
      {/* <TabPanel value={tab} index={0}>
        <Description />
      </TabPanel> */}
      <TabPanel value={tab} index={0}>
        <Material />
      </TabPanel>
      <TabPanel value={tab} index={1}>
        <Shipping />
      </TabPanel>
      <TabPanel value={tab} index={2}>
        <Customization />
      </TabPanel>
    </Box>
  );
}
